module.exports = __webpack_public_path__ + "img/honor-of-kings.bc8fd2e3.png";